import { Box } from "@mui/material";
import MuiTabs, {
  TabsDetails,
} from "../../../../components/common/tabs/MuiTabs";
import { useEffect } from "react";
import { useAppDispatch } from "../../../../app/features/store/store";
import {
  clearCollectiveManifestData,
  clearCollectiveManifestDataImport,
  updateStoreManifestList,
} from "../../../../app/features/dedicatedReceiving/storeManifestSlice";
import { useNavigate, useParams } from "react-router-dom";
import StoreManifestView from "../StoreManifestView";
import StoreManifestImport from "../StoreManifestImport";

const ManifestDashboard = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { storePrimaryId } = useParams();

  useEffect(() => {
    if (!Number(storePrimaryId)) {
      navigate(`/manifest-store-selection`);
    }
  }, [storePrimaryId]);

  useEffect(() => {
    return () => {
      dispatch(updateStoreManifestList([]));
      dispatch(clearCollectiveManifestData());
      dispatch(clearCollectiveManifestDataImport());
    };
  }, [dispatch]);

  const tabsValues: TabsDetails[] = [
    {
      tabName: " Store Manifest",
      tabContent: (
        <StoreManifestView selectedStoreId={Number(storePrimaryId)} />
      ),
      index: 0,
    },
    {
      tabName: "Store Manifest Data Import",
      tabContent: (
        <StoreManifestImport selectedStoreId={Number(storePrimaryId)} />
      ),
      index: 1,
    },
  ];

  return (
    <>
      <Box>
        <MuiTabs tabDetails={tabsValues} />
      </Box>
    </>
  );
};

export default ManifestDashboard;
